/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import FloatingMenu from "../components/FloatingMenu";
import { useEffect, useState } from "react";

const Seventop = () => {
  const [sevenTop, setSevenTop] = useState([]);

  useEffect(() => {
    fetchSevenTop();
  }, []);

  const fetchSevenTop = async () => {
    try {
      const response = await fetch(
        "https://cms.okoce.net/api/admin/seven-tops"
      );
      if (!response.ok) {
        throw new Error("Gagal mengambil data 7 top");
      }
      const data = await response.json();
      setSevenTop(data.data[0] || []);
    } catch (error) {
      setSevenTop([]);
    }
  };

  return (
    <>
      <div className="bg-gray-100 min-h-screen pb-10">
        <div className="mt-24">
          <img
            className="w-full"
            src={`${process.env.REACT_APP_API_URL}/${sevenTop.background_image}`}
            alt="Header"
          />
        </div>
        <div className="flex justify-around mt-10">
          <div className="">
            <img
              src={`${process.env.REACT_APP_API_URL}/${sevenTop.image}`}
              className="object-cover lg:max-w-[40rem] mobile:max-w-72"
              alt="7 Top Ok Oce"
            />
          </div>
        </div>
        <div className="max-w-5xl mx-auto mt-10 px-6">
          {sevenTop?.content?.map(
            ({ content_title, content_description, content_url }, index) => (
              <a
                href={content_url}
                className="mt-10 mx-auto flex items-center bg-white rounded-lg shadow-lg flex-col lg:flex-row lg:w-[40rem] lg:h-[7rem]"
                key={index}
              >
                <div
                  className={
                    index % 2 === 0
                      ? "bg-[#1c75ac] p-4 flex items-center justify-center text-center text-xl text-white font-bold w-full h-28 rounded-t-lg lg:rounded-none lg:rounded-l-lg lg:w-1/3 lg:h-full"
                      : "bg-[#e01f31] p-4 flex items-center justify-center text-center text-xl text-white font-bold w-full h-28 rounded-t-lg lg:rounded-none lg:rounded-l-lg lg:w-1/3 lg:h-full"
                  }
                >
                  {content_title}
                </div>
                <div className="text-md p-6 my-4 text-zinc-800 w-full text-center lg:text-left lg:w-3/4 lg:my-0">
                  {content_description}
                </div>
              </a>
            )
          )}
        </div>
        <FloatingMenu />
      </div>
    </>
  );
};

export default Seventop;
